'use strict'
export default {
  data () {
    return {
    }
  },
  methods: {
    GetBrowser: function () {
      // UA判定
      if (window.navigator.userAgent.toLowerCase().indexOf('msie') !== -1 &&
        window.navigator.userAgent.toLowerCase().indexOf('trident') !== -1) {
        return 'ie'
      } else if (window.navigator.userAgent.toLowerCase().indexOf('edge') !== -1) {
        return 'edge'
      } else if (window.navigator.userAgent.toLowerCase().indexOf('chrome') !== -1) {
        return 'chrome'
      } else if (window.navigator.userAgent.toLowerCase().indexOf('safari') !== -1) {
        return 'safari'
      } else {
        return 'others'
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/UserAgentMixin.js